<script setup lang="ts">
import { useLongPressTooltip } from "@/composable/useLongPressTooltip";
import { useSlots, computed } from "vue";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

const props = withDefaults(
  defineProps<{
    /** Outil sélectionné (fond bleu plein). */
    active?: boolean;
    /** Mode allumé (aide au tracé, règles) : plus discret que `active`. */
    mode?: boolean;
    icon?: string;
    phosphorIcon?: string;
    phosphorWeight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
    tooltipText?: string;
    tooltipTitle?: string;
    disabled?: boolean;
    size?: "sm" | "md" | "lg" | "nosize";
  }>(),
  {
    disabled: false,
    phosphorWeight: "duotone",
    size: "md",
  },
);

const slots = useSlots();
const hasText = computed(() => !!slots.default);

// Icon size based on button size
const iconSize = computed(() => {
  switch (props.size) {
    case "sm":
      return 16;
    case "lg":
      return 24;
    default:
      return 20;
  }
});

const { refHook } = useLongPressTooltip();
</script>

<template>
  <button
    ref="refHook"
    :disabled="disabled"
    :class="[
      'canvas-btn',
      `canvas-btn-${size}`,
      { active, 'mode-on': mode, 'has-text': hasText },
    ]"
    :data-bs-content="tooltipText"
    :data-bs-title="tooltipTitle"
  >
    <!-- Phosphor icon (new) -->
    <PhosphorIcon
      v-if="phosphorIcon"
      :name="phosphorIcon"
      :size="iconSize"
      :weight="phosphorWeight"
    />
    <!-- Bootstrap icon (legacy) -->
    <i v-else-if="icon" :class="`bi-${icon}`"></i>
    <slot />
  </button>
</template>
